import { messages } from './ReportCreatePopup.messages';
import { ActiveStep } from './ReportCreatePopup.types';

export const subtitles: Record<ActiveStep, string> = {
    [ActiveStep.ReportType]: messages.subtitleStepReportType,
    [ActiveStep.Filters]: messages.subtitleStepFilters,
    [ActiveStep.VisibleColumns]: messages.subtitleStepVisibleColumns,
    [ActiveStep.ReportName]: messages.subtitleStepReportName,
};
